export default __webpack_public_path__ + "static/media/IMG_9004 copie.56fc5b11.jpg";